import { Injectable, signal } from '@angular/core';
import { ICredentials, IDataLogin, IUsuarioLogin } from '../interfaces/usuario.interface';
import { Router } from '@angular/router';
import { ConstantsService } from './constants.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ACCESS_TOKEN, API_URL, PATH_LOGIN, REFRESH_TOKEN, USER_DATA } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  isLoggedIn = signal<boolean>(false);
  user = signal<IUsuarioLogin>({});
  token = signal<any>(null);

  apiURL: string = `${API_URL}/auth`;

  constructor(
    private router: Router,
    private constantsService: ConstantsService,
    private http: HttpClient
  ) { }


  login(credentials: ICredentials): Observable<IDataLogin> {
    return this.http.post<IDataLogin>(`${this.apiURL}/login`, credentials);
  }

  recover(credentials: ICredentials): Observable<IDataLogin> {
    return this.http.post<IDataLogin>(`${this.apiURL}/forgot-password`, credentials);
  }

  /** Refresca el token */
  refreshToken(refreshToken: string): Observable<IDataLogin> {
    return this.http.post<IDataLogin>(`${this.apiURL}/refresh`, { refreshToken: refreshToken });
  }

  /** 
  * Crea el usuario y el token en localstorage
  * @param data: contiene la respuesta enviada por el login desde el backend
  */
  setSession(accessToken: string, refreshToken: string, recordarme: boolean = true) {
    if (accessToken && refreshToken) {
      const payload = this.parseJwt(accessToken);
      this.user.set(payload);
      if (recordarme) {
        const userData = {
          exp: payload.exp,
          email: payload.email,
          name: payload.name,
          sub: payload.sub
        }
        localStorage.setItem(USER_DATA, JSON.stringify(userData));
      }
      this.setTokens(accessToken, refreshToken);
    }
  }
  
  parseJwt(token: string) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join('')
    );
    return JSON.parse(jsonPayload);
  }

  /** Crea los tokens en localStorage */
  setTokens(accessToken: string, refreshToken: string) {
    localStorage.setItem(ACCESS_TOKEN, accessToken);
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
  }

  /** Comprueba si existe el Token */
  hasToken() {
    return !!localStorage.getItem(ACCESS_TOKEN);
  }

  /** Comprueba si existe el RefreshToken */
  hasRefreshToken() {
    return !!localStorage.getItem(REFRESH_TOKEN);
  }

  /** Retorna el Token desde localStorage */
  getAccessToken(): string {
    return localStorage.getItem(ACCESS_TOKEN) || '';
  }

  /** Retorna el Token desde localStorage */
  getRefreshToken(): string {
    return localStorage.getItem(REFRESH_TOKEN) || '';
  }

  /** Obtiene el usaurio desde localStorage */
  getUserSesion() {
    try {
      const user = JSON.parse(localStorage.getItem(USER_DATA) || 'null');
      if (user?.exp && user?.sub) return user;
    } catch {
    }
    return null;
  }

  /** Comprueba si el token aun es válido */
  isValidToken(token: string): boolean {
    if (!token) return false;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp > Date.now() / 1000;
    } catch (error) {
      return false;
    }
  }

  /** Elimina la sesión actual */
  logout() {
    localStorage.clear();
    this.isLoggedIn.set(false);
    this.user.set({})
    this.router.navigate([PATH_LOGIN]);
  }

  /** Verifica si existen los datos en localstorage */
  verifyLogin(redirect: boolean = true) {
    if (this.hasToken() && this.hasRefreshToken()) {
      this.isLoggedIn.set(true);
      if (redirect) {
        this.router.navigate(['/dashboard']);
      }
      return true;
    } else {
      this.isLoggedIn.set(false);
      this.logout();
      this.router.navigate([PATH_LOGIN]);
      return false;
    }
  }

}
